import { render, staticRenderFns } from "./SalesByProduct.vue?vue&type=template&id=df420bd8&"
import script from "./SalesByProduct.vue?vue&type=script&lang=js&"
export * from "./SalesByProduct.vue?vue&type=script&lang=js&"
import style0 from "./SalesByProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports